import React, { useContext } from 'react'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import { FirebaseContext } from '../firebase'
import useFormValidation from '../auth/useFormValidation'
import validateCreateSequence from '../auth/validateCreateSequence'
import { useHistory } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import CharacterCounter from 'react-character-counter'

const INITIAL_STATE = {
    name: "",
    description: ""
}

function CreateSequence() {

    const { fire, user } = useContext(FirebaseContext)
    const { handleChange, handleSubmit, handleBlur, values, errors } = useFormValidation(INITIAL_STATE, validateCreateSequence)
    const history = useHistory()

    function onSubmit(event) {
        event.preventDefault()
        const randomNum = Math.floor(Math.random() * 1000)
        const data = {
            name: values.name,
            description: values.description,
            img: `https://gradienthunt.com/gradients-images/${randomNum}.jpg`,
            createdBy: user.uid,
            created: Date.now()
        }
        fire.firestore().collection('sequences').add(data)
            .then(docRef => {
                history.push(`/edit/${docRef.id}`)
            })
            .catch(err => console.log(err))
    }

    return (
        <Container>
            <Card className="m-2 mt-4">
                <Card.Header as="h5">Create a new Sequence</Card.Header>
                <Card.Body>
                    <Form onSubmit={e => handleSubmit(e, onSubmit)}>
                        <Form.Group>
                            <Form.Label>Name</Form.Label>
                            <CharacterCounter value={values.name} maxLength={50}>
                                <Form.Control
                                    type="text"
                                    onChange={handleChange}
                                    name="name"
                                    className={errors.name && 'error-input'}
                                    onBlur={handleBlur}
                                    maxLength="50"
                                    value={values.name} />
                            </CharacterCounter>
                            {errors.name && <p className="error-text">{errors.name}</p>}
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Description <span className="text-muted">(optional)</span></Form.Label>
                            <CharacterCounter value={values.description} maxLength={250}>
                                <Form.Control
                                    as="textarea"
                                    rows="3"
                                    onChange={handleChange}
                                    name="description"
                                    value={values.description}
                                    maxLength="250"
                                    className={errors.description && 'error-input'}
                                    onBlur={handleBlur} />
                            </CharacterCounter>
                             {errors.description && <p className="error-text">{errors.description}</p>}
                        </Form.Group>
                        <div className="d-none d-sm-block">
                            <Button type="submit">Create Sequence</Button>
                            <LinkContainer to="/create" activeClassName="">
                                <Button className="ml-2" variant="outline-secondary">Cancel</Button>
                            </LinkContainer>
                        </div>
                        <div className="mobile-view d-block d-sm-none">
                            <Button block type="submit">Create Sequence</Button>
                            <LinkContainer to="/create" activeClassName="">
                                <Button block variant="outline-secondary">Cancel</Button>
                            </LinkContainer>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    )

}

export default CreateSequence